import React from "react";
import { Box, Typography, Grid, Fade, Grow } from "@mui/material";
import {
  Build,
  Computer,
  SportsGymnastics,
  MusicNote,
  SportsEsports,
  SportsTennis,
} from "@mui/icons-material";
import styled from "styled-components";

const InterestIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: linear-gradient(135deg, #0066cc 0%, #008cff 100%);
  color: white;
  margin: 0 auto 1rem;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.1);
  }
`;

function InterestsSection() {
  const interests = [
    { icon: <Computer />, label: "Computer Building" },
    { icon: <SportsGymnastics />, label: "Disc Golf" },
    { icon: <SportsTennis />, label: "Pickleball" },
    { icon: <MusicNote />, label: "Music Production" },
    { icon: <SportsEsports />, label: "Video Games" },
  ];

  return (
    <Box sx={{ mt: 8 }}>
      <Fade in timeout={2100}>
        <Typography
          variant="h4"
          component="h3"
          textAlign="center"
          gutterBottom
          sx={{
            fontWeight: 600,
            mb: 4,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
          }}
        >
          <Build sx={{ color: "#0066CC" }} />
          Interests
        </Typography>
      </Fade>

      <Grid container spacing={3} justifyContent="center">
        {interests.map((interest, index) => (
          <Grid item xs={6} sm={4} md={2} key={interest.label}>
            <Grow in timeout={2200 + index * 100}>
              <Box sx={{ textAlign: "center" }}>
                <InterestIcon>{interest.icon}</InterestIcon>
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  {interest.label}
                </Typography>
              </Box>
            </Grow>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default InterestsSection;
